module.exports = __webpack_public_path__ + "static/img/pc_product.cfecaae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/pc_product.png
// module id = QWTf
// module chunks = 1